import { Step } from 'react-joyride';

const GenerateQRTourSteps: Step[] = [
  // ── 1. Título ──────────────────────────────────────────────────────────────
  {
    target: '.tour-title',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Bienvenido a <strong>Web, QR y tarjetas</strong>. Desde aquí controlas
        la identidad visual de tu negocio online: los colores de tu web, los
        códigos QR para reservas y catálogo, y tus tarjetas de presentación
        digitales.
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true,
  },

  // ── 2. Botón ayuda ─────────────────────────────────────────────────────────
  {
    target: '.tour-help-btn',
    content: (
      <div style={{ textAlign: 'justify' }}>
        En cualquier momento puedes volver a ver esta guía haciendo clic en{' '}
        <strong>Ayuda</strong>.
      </div>
    ),
    placement: 'left',
    disableBeacon: true,
  },

  // ── 3. Sección colores ─────────────────────────────────────────────────────
  {
    target: '.tour-colors-card',
    content: (
      <div style={{ textAlign: 'justify' }}>
        En esta sección configuras los <strong>colores de tu página web</strong>
        . Estos colores se aplican automáticamente en tu perfil público, el
        widget de reservas y tus tarjetas de presentación.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },

  // ── 4. Color primario ──────────────────────────────────────────────────────
  {
    target: '.tour-color-primary',
    content: (
      <div style={{ textAlign: 'justify' }}>
        El <strong>color primario</strong> se usa en botones, CTAs y elementos
        destacados. Puedes elegirlo de tres formas:
        <ul style={{ margin: '8px 0 0 16px' }}>
          <li>Pulsa el círculo para abrir el selector de color</li>
          <li>Escribe directamente el código HEX (p.ej. #e63950)</li>
          <li>Elige uno de los colores de la paleta rápida</li>
        </ul>
      </div>
    ),
    placement: 'right',
    disableBeacon: true,
  },

  // ── 5. Color secundario ────────────────────────────────────────────────────
  {
    target: '.tour-color-secondary',
    content: (
      <div style={{ textAlign: 'justify' }}>
        El <strong>color secundario</strong> se aplica en fondos, textos y
        acentos visuales. Funciona igual que el primario: selector, HEX o paleta
        rápida.
        <br />
        <br />
        Intenta que ambos colores contrasten bien entre sí para garantizar una
        buena legibilidad en tu web.
      </div>
    ),
    placement: 'left',
    disableBeacon: true,
  },

  // ── 6. Preview + Guardar ───────────────────────────────────────────────────
  {
    target: '.tour-colors-save',
    content: (
      <div style={{ textAlign: 'justify' }}>
        El botón de <strong>Vista previa</strong> abre tu web en una pestaña
        nueva para que compruebes cómo quedan los colores antes de guardar.
        <br />
        <br />
        Cuando estés satisfecho, pulsa <strong>Guardar colores</strong> para
        aplicarlos definitivamente en tu perfil público.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },

  // ── 7. QR Catálogo ─────────────────────────────────────────────────────────
  {
    target: '.tour-qr-catalogo',
    content: (
      <div style={{ textAlign: 'justify' }}>
        El <strong>QR de catálogo</strong> lleva a tus clientes directamente a
        tu listado de servicios, sin necesidad de reservar. Ideal para colocarlo
        en escaparates, folletos o redes sociales.
        <br />
        <br />
        Si ya tienes un QR generado, el icono de la papelera en la esquina
        superior derecha te permite eliminarlo.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },

  // ── 8. Acciones QR Catálogo ────────────────────────────────────────────────
  {
    target: '.tour-qr-catalogo-actions',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Una vez generado el QR de catálogo puedes:
        <ul style={{ margin: '8px 0 0 16px' }}>
          <li>
            <strong>Descargarlo</strong> como imagen para imprimirlo o
            compartirlo
          </li>
          <li>
            <strong>Copiar el enlace</strong> para pegarlo donde necesites
          </li>
        </ul>
        <br />
        Si aún no tienes QR, pulsa <em>"Generar QR catálogo"</em> para crearlo.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },

  // ── 9. QR Citas ────────────────────────────────────────────────────────────
  {
    target: '.tour-qr-citas',
    content: (
      <div style={{ textAlign: 'justify' }}>
        El <strong>QR de citas</strong> lleva a tus clientes directamente al
        formulario de reserva online. Puedes colocarlo en tu web, WhatsApp,
        Instagram o imprimirlo en tu local.
        <br />
        <br />
        La pastilla de estado te indica en todo momento si las reservas online
        están activas o pausadas.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },

  // ── 10. Switch reservas ────────────────────────────────────────────────────
  {
    target: '.tour-switch-reservas',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Este interruptor <strong>activa o desactiva las reservas online</strong>
        . Cuando está desactivado, el QR sigue existiendo pero los clientes no
        podrán completar nuevas reservas.
        <br />
        <br />
        Útil para pausar temporalmente las reservas en períodos de vacaciones o
        saturación.
      </div>
    ),
    placement: 'right',
    disableBeacon: true,
  },

  // ── 11. Acciones QR Citas ──────────────────────────────────────────────────
  {
    target: '.tour-qr-citas-actions',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Una vez generado el QR de citas puedes:
        <ul style={{ margin: '8px 0 0 16px' }}>
          <li>
            <strong>Descargarlo</strong> como imagen para imprimirlo o
            compartirlo
          </li>
          <li>
            <strong>Copiar el enlace</strong> para enviarlo por WhatsApp, email
            o redes
          </li>
        </ul>
        <br />
        Si aún no tienes QR, pulsa <em>"Generar QR citas"</em> para crearlo.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },

  // ── 12. Sección tarjetas de presentación ───────────────────────────────────
  {
    target: '.tour-cards-section',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Aquí gestionas las <strong>tarjetas de presentación digitales</strong>{' '}
        de tu negocio. Puedes crear una por cada persona o trabajador, con su
        propio diseño, datos de contacto y QR.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },

  // ── 13. Nueva tarjeta ───────────────────────────────────────────────────────
  {
    target: '.tour-cards-new-btn',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Pulsa <strong>Nueva tarjeta</strong> para crear una tarjeta de
        presentación: nombre, puesto, datos de contacto, descripción, redes
        sociales y qué QR mostrar (citas y/o catálogo).
      </div>
    ),
    placement: 'left',
    disableBeacon: true,
  },

  // ── 14. Acciones de cada tarjeta ────────────────────────────────────────────
  {
    target: '.tour-card-actions',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Para cada tarjeta puedes:
        <ul style={{ margin: '8px 0 0 16px' }}>
          <li>
            Descargarla como <strong>PNG</strong> (cara y dorso por separado)
          </li>
          <li>
            Descargarla como <strong>PDF</strong> de 2 páginas, lista para
            imprimir
          </li>
          <li>
            <strong>Editarla</strong> con el lápiz o <strong>eliminarla</strong>{' '}
            con la papelera
          </li>
        </ul>
        <br />
        Al descargar, podrás elegir el <strong>tamaño exacto</strong> de la
        tarjeta (8×5, 8.5×5.5 o 9×5 cm).
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true,
  },

  // ── 15. Paginación de tarjetas ──────────────────────────────────────────────
  {
    target: '.tour-cards-pagination',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Si tienes muchas tarjetas creadas, se organizan en{' '}
        <strong>páginas</strong>. Usa las flechas para navegar entre ellas y el
        selector para elegir cuántas tarjetas ver por página.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
];

export default GenerateQRTourSteps;